export default __webpack_public_path__ + "static/media/use-case-finance.30853e9e.gif";